import { Warning } from '@phosphor-icons/react';

export default Warning;
